






import Vue from 'vue';
import { Actions } from '@/store/actions';
import { Guide } from '@/models/guides';
import { typedStore } from '@/store';
import { Guides } from './guides';
import { Notification } from '@/models';
import { Notifications } from './notifications';

export default Vue.extend({
  name: 'Popups',
  async beforeCreate(): Promise<void> {
    await this.$store.dispatch(Actions.guides.fetchAllGuides);
    await this.$store.dispatch(Actions.notifications.fetch);
  },
  components: {
    Guides: () => Promise.resolve(Guides),
    Notifications: () => Promise.resolve(Notifications),
  },
  computed: {
    hasAnyGuides(): boolean {
      return typedStore(this).state.guides.allGuides.length > 0;
    },
    hasAnyNotifications(): boolean {
      return typedStore(this).state.notifications.items.length > 0;
    },
    popupToDisplay(): string | null {
      if (this.hasAnyGuides) {
        return 'Guides';
      }
      if (this.hasAnyNotifications) {
          return 'Notifications';
      }

      return null;
    },
  },
});
